// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
import Page from "types/fields/entries/page";
import Style from "types/globals/styleguide/style";
import ButtonType from "types/common/buttonType";
// MARK: Functionality
import URI from "utils/common/uri";
import CSSStyles from "enums/cssStyles";
// MARK: Styled Components

interface StandardButtonProps {
  dangerouslySetInnerHTML: any;
  color: string;
  backgroundcolor: string;
}

const StandardButton = styled(({ ...props }) => (
  <Link {...props} />
))<StandardButtonProps>`
  display: flex;
  border: ${({ color }) => "1px solid " + color};
  width: 100%;
  padding: 10px 10px;
  max-width: 500px;
  transition: 0.67s;
  text-decoration: none;

  color: ${({ color }) => color};
  background-color: ${({ backgroundcolor }) => backgroundcolor};

  pointer-events: all !important;
  user-select: auto !important;
  cursor: pointer !important;

  justify-content: center;
  align-items: center;
  text-align: center;

  :hover {
    background-color: ${({ color }) => color}; !important;
    color: ${({ backgroundcolor }) => backgroundcolor} !important;
    border: 1px solid ${({ backgroundcolor }) => backgroundcolor} !important;
  }
  text-wrap: balance;
`;

const StandardExternalButton = styled(({ ...props }) => (
  <a target="_blank" {...props} />
))<StandardButtonProps>`
  display: flex;
  border: ${({ color }) => "1px solid " + color};
  width: 100%;
  padding: 10px 10px;
  max-width: 500px;
  transition: 0.67s;
  text-decoration: none;

  color: ${({ color }) => color};
  background-color: ${({ backgroundcolor }) => backgroundcolor};

  pointer-events: all !important;
  user-select: auto !important;
  cursor: pointer !important;

  justify-content: center;
  align-items: center;
  text-align: center;

  :hover {
    background-color: ${({ color }) => color}; !important;
    color: ${({ backgroundcolor }) => backgroundcolor} !important;
    border: 1px solid ${({ backgroundcolor }) => backgroundcolor} !important;
  }
  text-wrap: balance;
`;

interface ButtonBoxProps {
  margintop?: number;
  marginleft?: number;
}

const ButtonBox = styled.div<ButtonBoxProps>`
  display: flex;
  width: 100%;
  padding: 10px 10px;
  margin-top: ${({ margintop }) => (margintop ? margintop + "px" : "")};
  margin-left: ${({ marginleft }) => (marginleft ? marginleft + "px" : "")};
  justify-content: center;
  align-items: center;
  text-align: center;
`;

// MARK: React Component
// Props

interface ButtonProps {
  page?: Page;
  children: any;
  type?: ButtonType;
  marginleft?: number;
  margintop?: number;
  linkIdentifier?: string;
  onClick?: () => void;
}
// Styleguide & Datapoints
const getDataPoints = (styleguide: ReduxStyleguide) => {
  const { colors } = styleguide;
  const { primary, background } = colors;
  return {
    style: CSSStyles.navigation,
    primary: primary,
    background: background,
  };
};
// Component
const TextButton = ({
  page,
  children,
  type,
  marginleft,
  margintop,
  linkIdentifier,
  onClick,
}: ButtonProps) => {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: Variables
  const { style, primary, background } = getDataPoints(styleguide);
  var addToLink: string = "";
  var buttonType: ButtonType = type === undefined ? "secondary" : type;
  if (linkIdentifier) {
    addToLink = "#" + linkIdentifier;
  }

  // MARK: Render
  if (page) {
    switch (page?.sectionHandle) {
      case "externalLinks":
        return (
          <ButtonBox margintop={margintop} marginleft={marginleft}>
            <StandardExternalButton
              href={page.externalUrl + addToLink}
              className={style}
              dangerouslySetInnerHTML={{ __html: children }}
              color={buttonType === "primary" ? background : primary}
              backgroundcolor={buttonType === "primary" ? primary : background}
              onClick={onClick}
            />
          </ButtonBox>
        );
      default:
        return (
          <ButtonBox margintop={margintop} marginleft={marginleft}>
            <StandardButton
              to={URI(page?.uri) + addToLink}
              className={style}
              dangerouslySetInnerHTML={{ __html: children }}
              color={buttonType === "primary" ? background : primary}
              backgroundcolor={buttonType === "primary" ? primary : background}
              onClick={onClick}
            />
          </ButtonBox>
        );
    }
  } else {
    return <div />;
  }
};

export default TextButton;
